export default function embedCodeDropdownComponent() {
  return {};
}
